import React from 'react';
import TenantManagement from './TenantManagement';

interface AdminDashboardProps {
  user?: {
    email: string;
  };
}

const AdminDashboard: React.FC<AdminDashboardProps> = ({ user }) => {
  return (
    <div className="w-full">
      <TenantManagement />
    </div>
  );
};

export default AdminDashboard;
